












































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { EditorialProject, PrepTaskStatus, ProductionPrepAreaSummary, ProductionPrepPendingTask, ProductionPrepSummary } from '@/models'
import {
  AREA_PROGRESS,
  AREA_PROGRESS_ICONS,
  ONGOING_PREP_TASK_STATUSES,
  PrepStateView,
  PrepTaskStatusOption,
  areaApplicableTasks,
  isAreaOpenByDefault,
  ongoingSince,
  percent,
  prepTaskStatusOption,
  prepStateView,
  prepSummaryTotals,
  PrepSummaryTotals
} from '@/utils/production-prep'
import { ROLE_ADMIN } from '@/utils/constants'
import PrepAreaCard from '@/components/productionPrep/PrepAreaCard.vue'
import PrepProgressHeader from '@/components/productionPrep/PrepProgressHeader.vue'

/**
 * Read-only state of the preparation of a production project: is everything ready and, if not,
 * what each area still lacks. Opened from the calendar, apart from the project detail.
 */
@Component({
  components: { PrepAreaCard, PrepProgressHeader }
})
export default class ProductionPrepStatusModal extends Vue {
  @Prop({ default: null }) project: EditorialProject | null
  @Prop({ default: null }) prep: ProductionPrepSummary | null

  private ROLE_ADMIN = ROLE_ADMIN
  private AREA_PROGRESS = AREA_PROGRESS
  private ONGOING_STATUSES = ONGOING_PREP_TASK_STATUSES
  private percent = percent
  private areaApplicableTasks = areaApplicableTasks
  private areaToggles: { [areaId: number]: boolean } = {}

  get totals(): PrepSummaryTotals {
    return prepSummaryTotals(this.prep as ProductionPrepSummary)
  }

  /** Every time it opens, the areas start as the preparation detail opens them */
  resetToggles() {
    this.areaToggles = {}
  }

  get state(): PrepStateView {
    return prepStateView(this, this.totals.applicable, this.totals.done)
  }

  areaIcon(area: ProductionPrepAreaSummary): { icon: string; variant: string } {
    return AREA_PROGRESS_ICONS[area.progress]
  }

  /** Same as the preparation detail: done and not applicable areas collapsed, the rest open */
  isAreaOpen(area: ProductionPrepAreaSummary): boolean {
    return area.id in this.areaToggles ? this.areaToggles[area.id] : isAreaOpenByDefault(area.progress)
  }

  toggleArea(area: ProductionPrepAreaSummary) {
    if (!area.pendingTasks.length) return
    this.$set(this.areaToggles, area.id, !this.isAreaOpen(area))
  }

  statusOption(status: PrepTaskStatus): PrepTaskStatusOption {
    return prepTaskStatusOption(status)
  }

  since(task: ProductionPrepPendingTask): string {
    return ongoingSince(this, task.status, task.statusUpdatedOn)
  }
}
